import React from 'react'
import EstadoInscripcionBadge from '../admin/inscripciones/EstadoInscripcionBadge'

// Indicadores de participacion dentro del grupo (F2): que le falta a cada jugador,
// visible donde el coach trabaja. Contraparte del candado suave -- el candado exige
// la inscripcion; esto vigila el papeleo sin bloquear a nadie.
//
// 'activo' no pinta nada: lo normal no necesita badge. Solo se marca lo que pide
// atencion, para que la lista no se convierta en un arbol de navidad donde nada
// resalta.
const EstadoParticipacionBadges = ({ estado, adeudo }) => {
  const mostrarEstado = estado && estado !== 'activo'
  if (!mostrarEstado && !adeudo) return null

  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      {mostrarEstado && <EstadoInscripcionBadge estado={estado} />}
      {adeudo && (
        <span className="inline-flex rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium leading-none text-red-700">
          Adeudo
        </span>
      )}
    </span>
  )
}

export default EstadoParticipacionBadges
